import { Trans, useTranslation } from 'react-i18next';
import { LabelInput } from '../InputField/style/LabelInput';

type LabelProps = { domId: string; label: string };

const Label = (props: LabelProps) => {
  const { domId, label } = props;
  const { t } = useTranslation();

  return (
    <LabelInput htmlFor={domId}>
      <Trans t={t} i18nKey={label} />
    </LabelInput>
  );
};

export default Label;
